import {FarmCard} from '@/components/FarmCard';
import ResultView, {useResultView} from '@/components/ResultView';
import {visitSeed} from '@/lib/visitSeed';
import ResultOrder from "@/components/ResultOrder";
import { activeAtlasFilters } from '@/lib/atlasScope';
import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { DataMessage } from "@/components/Editorial";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";
import AtlasFilters from "@/components/AtlasFilters";

export default function Atlas() {
  const { lang } = useLang();
  const [view,setView]=useResultView();
  const [params, setParams] = useSearchParams();
  const filters = Object.fromEntries(params.entries());
  const filterKey = params.toString();
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);
  const [order, setOrder] = useState("random"), [page, setPage] = useState(1);
  const [meta, setMeta] = useState({total:0, pages:1});
  const [seed] = useState(visitSeed);
  useEffect(() => setPage(1), [filterKey, order]);
  const [attempt, setAttempt] = useState(0);
  const hasRequested = useRef(false);
  useEffect(() => {
    const controller = new AbortController(); setItems(null); setError(false);
    const timer = setTimeout(() => {
      hasRequested.current = true;
      api.get('/farms', { params: { ...activeAtlasFilters(Object.fromEntries(new URLSearchParams(filterKey))), paginated:true, summary:true, page_size:24, order, seed, page }, signal: controller.signal })
      .then(r => { if (!controller.signal.aborted) { setItems(r.data.items); setMeta({total:r.data.total, pages:r.data.pages}); setPage(r.data.page); } })
      .catch(() => { if (!controller.signal.aborted) setError(true); });
    }, hasRequested.current ? 250 : 0);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [filterKey, attempt, order, seed, page]);
  return <div className="grain-bg min-h-[60vh] py-12"><div className="max-w-6xl mx-auto px-4">
    <h1 className="font-serif text-4xl text-[#2A2521]">{lang === "it" ? "Atlante dei soggetti" : "Subject atlas"}</h1>
    <label className="block mt-5 text-sm">{lang === 'it' ? 'Cerca soggetto, località o riferimento biologico' : 'Search subject, location or biological reference'}
      <input className="block w-full border rounded-md p-2 mt-1" value={filters.search || ''} onChange={e => setParams(Object.fromEntries(Object.entries({ ...filters, search: e.target.value }).filter(([,v]) => v)))} />
    </label>
    <AtlasFilters value={filters} onChange={next => setParams(Object.fromEntries(Object.entries(next).filter(([,v]) => v)))} />
    <button type="button" className="underline mb-4" onClick={() => setParams({})}>{lang === 'it' ? 'Azzera filtri' : 'Clear filters'}</button>
    <ResultOrder order={order} onOrder={setOrder} page={page} pages={meta.pages} total={meta.total} onPage={setPage} loading={items === null} error={error} />
    <ResultView value={view} onChange={setView}/>
    {error ? <DataMessage error onRetry={() => setAttempt(a => a + 1)} retryLabel={lang === "it" ? "Riprova" : "Retry"}>{lang === "it" ? "Impossibile caricare i profili." : "Could not load profiles."}</DataMessage>
      : items === null ? <p role="status">{lang === "it" ? "Caricamento…" : "Loading…"}</p>
      : items.length === 0 ? <DataMessage>{lang === "it" ? "Non ci sono ancora profili in questa categoria. Puoi esplorare le altre categorie oppure creare il profilo del soggetto che gestisci." : "There are no profiles in this category yet. Explore other categories or create a profile for a subject you manage."}<Link to="/register" className="block mt-3 underline">{lang === "it" ? "Partecipa a PlantAdopting" : "Join PlantAdopting"}</Link></DataMessage>
      : <div className={view==='compact'?'grid gap-3':'grid gap-5 md:grid-cols-2 lg:grid-cols-3'}>{items.map(item=><FarmCard key={item.id} farm={item} compact={view==='compact'}/>)}</div>}
  </div></div>;
}


